import {request} from '@/network/request'

export function fetchList(query) {
  return request({
    url: '/gaoligong/dna/page',
    method: 'get',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/gaoligong/dna',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/gaoligong/dna/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/gaoligong/dna/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/gaoligong/dna',
    method: 'put',
    data: obj
  })
}
